import { Component, OnInit } from '@angular/core';
import { SessionService } from '@monsido/ng2/core/session/session.service';
import { StateService } from '@uirouter/core';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { activeFeatures } from '@monsido/ng2/core/constants/general.constant';
import { MonUIRouterTransitionService } from '@monsido/ng2/services/ui-router-transition-service/ui-router-transition-service';
import { PipeService } from '@client/app/filters/pipe-transformation.service';
import { ReadabilityRepoService } from '@client/app/services/api/readability-repo/readability-repo.service';
import { ReadabilityScoreResponse } from '@client/app/services/api/readability-repo/readability-repo.type';


@Component({
    selector: 'readability-checker',
    standalone: false,
    templateUrl: './checker.component.html',
})
export class ReadabilityCheckerComponent implements OnInit {
    subheaderTranslation: string = '';
    maxCharactersErrorMessage: string = '';
    readability_test_name: string = '';
    maxCharacters: number = 100000;
    loading: boolean = false;
    textToCheck: string = '';
    readabilityScore: number | null = null;
    readabilityLevel: string = '';
    error: string = '';
    domain: any;

    constructor (
        private stateService: StateService,
        private sessionService: SessionService,
        private readabilityRepoService: ReadabilityRepoService,
        private translateService: TranslateService,
        private monUIRouterTransitionService: MonUIRouterTransitionService,
        private pipeService: PipeService,
    ) { }

    ngOnInit () {
        if (!activeFeatures.readability) {
            return this.monUIRouterTransitionService.onTransitionFinished(
                () => {
                    this.stateService.go('base.dashboard');
                },
            );
        }
        this.domain = this.sessionService.domain;
        this.readability_test_name = this.pipeService.get('translateReadability')(this.domain.features.readability_test);
        this.subheaderTranslation = this.translateService.getString(`Calculate the readability score of any text (based on [[testName]])`,
            { testName: this.readability_test_name });
        this.maxCharactersErrorMessage = this.translateService.getString('You can only calculate a score for up to [[count]] characters.',
            { count: this.pipeService.get('monNumber')(this.maxCharacters) });
    }

    calculateReadability () {
        const params = {
            readability_test: this.domain.features.readability_test,
            readability_test_min_words: 0,
            language: this.domain.language,
            text: this.textToCheck,
        };
        this.loading = true;
        this.error = '';
        this.readabilityScore = null;

        this.readabilityRepoService.readabilityScore(params)
            .then((data: ReadabilityScoreResponse) => {
                this.readabilityLevel = data.readability_level;
                this.readabilityScore = data.readability;
                this.error = '';
            })
            .catch((error) => {
                this.readabilityScore = null;

                if (error && error.status) {
                    switch (error.status) {
                        case 403:
                            this.error = this.translateService.getString('You do not have sufficient permissions to use this feature.');
                            break;
                        case 404:
                            this.error = this.translateService.getString(`An error occurred while generating the score.
                                Please refresh the page and try again.`);
                            break;
                        case 422:
                            this.error = this.translateService.getString('Request failed. Please ensure you have added only text in the input field.');
                            break;
                        default:
                            this.error = this.translateService.getString('An unexpected error occurred. Please try again.');
                            break;
                    }
                } else {
                    this.error = this.translateService.getString('An unexpected error occurred. Please try again.');
                }
            })
            .finally(() => {
                this.loading = false;
            });
    }
}
